export const AUTH = "AUTH";

export const LOGOUT = "LOGOUT";

export const FETCH_ALL = "FETCH_ALL";

export const FETCH_ONE_TICKET = "FETCH_ONE_TICKET";

export const FETCH_MY_TICKET = "FETCH_MY_TICKET";

export const CREATE = "CREATE";

export const UPDATE_TICKET = "UPDATE_TICKET";

export const FETCH_ONE_PROJECT = "FETCH_ONE_PROJECT";

export const UPDATE_PROJECT = "UPDATE_PROJECT";
